if (
  typeof Object !== undefined
  && Object.prototype
  && !Object.prototype.diffKeys
) {
  Object.defineProperty(Object.prototype, 'diffKeys', {
    value(comparisonObj) {
      return Object.keys(this).reduce((result, key) => {
        if (!comparisonObj.hasOwnProperty(key)) {
          result.push(key);
        } else if (_.isEqual(this[key], comparisonObj[key])) {
          const resultKeyIndex = result.indexOf(key);
          result.splice(resultKeyIndex, 1);
        }
        return result;
      }, Object.keys(comparisonObj));
    }
  });
}